export default __webpack_public_path__ + "static/media/workinghours.26817129.svg";